import { Stato } from 'features/ippica/types';
import styles from './VirtualScommesseTablePosition.module.scss';

export type VirtualScommesseTablePositionProps = {
  stato: Stato;
  posizioneFinale?: number;
  posizionePartenza: number;
  numeroGabbia?: number;
  containerClassName?: string;
};

export const VirtualScommesseTablePosition = ({
  stato,
  posizioneFinale,
  posizionePartenza,
  numeroGabbia,
  containerClassName,
}: VirtualScommesseTablePositionProps) => {
  return (
    <div className={`${styles.container} ${containerClassName ? containerClassName : ''}`}>
      {stato === Stato.Chiusa && <span className={styles.highlighted}>{posizioneFinale}&deg;</span>}
      <p
        className={`${styles.position} ${!numeroGabbia && posizionePartenza < 10 ? styles.centeredPosition : ''}  ${
          stato === Stato.Chiusa ? styles.closed : ''
        }`}
      >
        {posizionePartenza}
        {numeroGabbia && <span className={styles.number}>{`(${numeroGabbia})`}</span>}
      </p>
    </div>
  );
};
